import comp from "./LearningGoalsModal";
export default comp;
